import { createAction } from '@reduxjs/toolkit';
import { myRequestsSlice } from './slice';

export const fetchMyRequestsCount = createAction('myRequests/fetchCount');
export const { setMyRequestsCount } = myRequestsSlice.actions;
